const joinExistingValues = (values: any[], separator = '') => {
  return values.filter((v) => !!v).join(separator);
};

export { joinExistingValues };
